import { render, staticRenderFns } from "./PrintLabelOrder.vue?vue&type=template&id=08f6446b&scoped=true"
import script from "./PrintLabelOrder.vue?vue&type=script&lang=js"
export * from "./PrintLabelOrder.vue?vue&type=script&lang=js"
import style0 from "./PrintLabelOrder.vue?vue&type=style&index=0&id=08f6446b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f6446b",
  null
  
)

export default component.exports